<template>
    <b-container>
        <b-container style="margin: 20px">
            <p>Thank you for your interest in becoming Napa Green Land certified. If you’re interested in
                hearing from peers about the benefits of Napa Green certification
                <a href="https://www.youtube.com/watch?time_continue=1&v=IP1rLhMGlng">please check out this video.</a>
            </p>

            <p>Napa Green Certified Land is an umbrella program that recognizes two highly-comparable third-
                party certification pathways - LandSmart and Fish Friendly Farming. Both of these partner
                programs are focused on watershed health and reducing erosion and sediment runoff for the
                health of Chinook salmon, steelhead trout and other riverine species. There are also elements
                focused on water efficiency, reducing or eliminating potentially harmful pesticides, protecting
                and restoring riparian habitat, caring for your workforce and being good neighbors.
            </p>
            <p>In addition, both of these programs facilitate compliance with the General Permit Waste
                Discharge Requirements from the Regional Water Quality Control Board. Both LandSmart and
                Fish Friendly Farming will work with you to develop and certify a custom Farm Plan for your vineyard
                property.</p>
            <p>Please fill out the information below. Once submitted you will receive an email with more
                information and contacts for both LandSmart and Fish Friendly Farming. Choose your own
                adventure based on which program appeals to you.
            </p>
            <p>Once certified please share your certificate and we will provide the benefits of Napa Green Land
                membership, including connection with the Napa Green knowledge network and community, recognition on
                NapaGreen.org, free Napa Green Certified signage, opportunity for logo use, access to BMP workshops,
                happy hours and other celebration and recognition events.
            </p>
            <p>We are always available to help answer any questions. Please reach out anytime.</p>

            <p><span style="font-style: italic"> Note: This is confidential program information.</span></p>
        </b-container>

        <b-form>
            <span style="margin-top: 10px"><br/></span>
            <b-container fluid>
                <b-container fluid>
                    <b-card bg-variant="light">

                        <b-form-group
                                label-cols-sm="4"
                                label="Site Manager Name:"
                                label-align-sm="left"
                                label-for="nested-street"
                        >
                            <b-form-input id="nested-company-name" size="sm" v-model="siteManager"
                                          placeholder="Site Manager Name">
                            </b-form-input>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-size="md"
                                label="Manager Phone:"
                                label-align-sm="left"
                                label-for="manager-phone"
                        >
                            <b-form-input id="manager-phone" size="sm" v-model="phone"
                                          placeholder="Manager Phone"></b-form-input>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Manager Email:"
                                label-for="input-sm">
                            <b-form-input id="input-me" size="sm" v-model="email"
                                          placeholder="Manager Email"></b-form-input>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Property Owner Name:"
                                label-for="input-sm">
                            <b-form-input id="propertyOwner" size="sm"
                                          v-model="propertyOwner" placeholder="Property Owner"></b-form-input>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Mailing Address:"
                                label-for="input-sm">
                            <b-form-input id="input-oa" size="sm" v-model="ownerAddress"
                                          placeholder="Owner Address"></b-form-input>
                        </b-form-group>

                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Owner Email/Phone:"
                                label-for="input-oem">
                            <b-form-input id="input-sm" size="sm" v-model="ownerEmail"
                                          placeholder="Owner Email"></b-form-input>
                        </b-form-group>
                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Vineyard Management Company:"
                                label-for="input-sm">
                            <b-form-input id="input-vmc" size="sm" v-model="vineyardManagementCompany"
                                          placeholder="Vineyard Management Company"></b-form-input>
                        </b-form-group>
                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Vineyard Name(s):"
                                label-for="input-sm">
                            <b-form-input id="input-vn" size="sm" v-model="vineyardNames"
                                          placeholder="Vineyard Names"></b-form-input>
                        </b-form-group>
                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Total Site Acreage:"
                                label-for="input-tsa">
                            <b-form-input id="input-tsa" size="sm" v-model="totalSiteAcreage"
                                          placeholder="Total Site Acreage"></b-form-input>
                        </b-form-group>
                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="Vineyard Acreage:"
                                label-for="input-sm">
                            <b-form-input id="input-sm" size="sm" v-model="vineyardAcreage"
                                          placeholder="Vineyard Acreage"></b-form-input>
                        </b-form-group>
                        <b-form-group
                                label-cols="4"
                                label-cols-lg="4"
                                label-size="md"
                                label="APN Number(s):"
                                label-for="input-sm">
                            <b-form-input id="input-sm" size="sm" v-model="apnNumbers"
                                          placeholder="APN Numbers"></b-form-input>
                        </b-form-group>

                        <b-container fluid>
                            <b-form-group
                                    label="Do any blue-line creeks or the Napa River run through or abut your property?:">
                                <b-form-radio-group
                                        v-model="propertyWaterCrossings"
                                        :options="yesNoOptions"
                                        name="clearResult"
                                        stacked
                                ></b-form-radio-group>
                            </b-form-group>
                            <b-form-group label="Have you participated in any voluntary riparian restoration projects, (e.g. Rutherford Reach,
Oakville to Oak Knoll, Selby Creek, Upper River, Carneros Creek)?">
                                <b-form-radio-group
                                        v-model="restorationProjects"
                                        :options="yesNoOptions"
                                        name="flavour-2a"
                                        stacked
                                ></b-form-radio-group>
                            </b-form-group>
                            <b-form-group label="Other Environmental Certifications (check those that apply):">
                                <b-form-checkbox-group
                                        v-model="certificationsSelected"
                                        :options="certificationsOptions"
                                        name="flavour-2a"
                                        stacked
                                ></b-form-checkbox-group>
                            </b-form-group>

                        </b-container>
                        <div class="button-holder">
                            <b-row align-h="center">
                                <b-col cols="2">
                                    <b-button style="color: white; background-color: green" class="submit-button"
                                              type="submit" @click="submit"
                                              variant="primary">Submit
                                    </b-button>
                                </b-col>
                                <b-col cols="2">
                                    <b-button style="color: white; background-color: green" class="cancel-button"
                                              type="cancel" @click="cancel"
                                              variant="primary">Cancel
                                    </b-button>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-container>
            </b-container>
        </b-form>
    </b-container>
</template>

<script>

    export default {
        name: "LandCertification",
        data() {
            return {
                email: "",
                propertyOwner: "",
                ownerAddress: "",
                siteManager: "",
                phone: "",
                ownerEmail: "",
                vineyardManagementCompany: "",
                vineyardNames: '',
                vineyardAcreage: '',
                waterSupplySource: "",
                totalSiteAcreage: "",
                apnNumbers: "",
                propertyWaterCrossings: '',
                restorationProjects: '',
                certificationsSelected: [],
                certificationsOptions: ["Organic", "CCOF", "Demeter Biodynamic", "Organic in-transition"],
                yesNoOptions: ["Yes", "No"]
            }
        },

        methods: {
            goToMyTeam: function () {
                console.log("Logging in.")
                this.$router.push({path: '/groups'});
            },
            goToAccountInfo: function () {
                console.log("Logging in.")
                this.$router.push({path: '/update-account-info'});
            },
            goToUpdatePassword: function () {
                console.log("Logging in.")
                this.$router.push({path: '/update-password'});
            }
            ,
            goToMySurvey: function () {
                console.log("Logging in.")
                this.$router.push({path: '/survey?surveyId=1'});
            },
            cancel: function () {
                alert('cancel');
            },
            submit: function () {
                console.log(this.fields);
                alert(this.fields);
                this.isSubmitted = false;
                this.$http.post('account/land-request', {
                    email: this.email,
                    propertyOwner: this.propertyOwner,
                    ownerAddress: this.ownerAddress,
                    siteManager: this.siteManager,
                    phone: this.phone,
                    ownerEmail: this.ownerAddress,
                    vineyardManagementCompany: this.vineyardManagementCompany,
                    vineyardNames: this.vineyardNames,
                    vineyardAcreage: this.vineyardAcreage,
                    waterSupplySource: this.waterSupplySource,
                    totalSiteAcreage: this.totalSiteAcreage,
                    apnNumbers: this.apnNumbers,
                    propertyWaterCrossings: this.propertyWaterCrossings,
                    restorationProjects: this.restorationProjects,
                    certificationsSelected: this.certificationsSelected
                })
                    .then(function (response) {
                        console.log(response.data);
                    })
                    .catch(function (error) {
                        console.log("Something went really wrong: ", error);
                    });
                this.$router.push('land-account-requested');
            }
        }
    }
</script>

<style scoped>

</style>
